<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_x"></a><a id="page_xi"></a><span class="small">FORGETTING THE ALAMO,<br/>OR,<br/>BLOOD MEMORY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292799325_09_haf1.vue?0831b377